enum PickupAndDeliveryOption {
  Delivery = 'delivery',
  Pickup = 'pickup',
  PickupAndDelivery = 'pickupAndDelivery'
}

export enum PickupAndDeliveryOptionUpperCase {
  Delivery = 'Delivery',
  Pickup = 'Pickup',
  PickupAndDelivery = 'PickupAndDelivery'
}

export default PickupAndDeliveryOption;
